angular.module('impactx.catalog').directive('ixCatalogApprovalInformation', function ()
{
    return {
        scope: {
            data: "=",
            trns: "=",
            withCurrentInformation: "="
        },
        restrict: 'E',
        templateUrl: 'modules/catalog/approval/templates/catalogapprovalinforamtion.tmpl.html',
        transclude: true
    };
});
